<template>
    <v-container fluid class="white px-0 elevation-4">
        <main-app-bar title="Orders">
            <template v-slot:buttons>
                <v-btn color="primary" @click="$router.push({name:'createOrder', params: { orderType }})"><v-icon left>mdi-plus</v-icon>Create order</v-btn>
            </template>
        </main-app-bar>
        <v-flex class="d-block grey lighten-4">
            <div class="pa-3">
                <v-btn-toggle
                    v-model="orderType"
                    color="primary"
                    tile
                    group
                    mandatory
                >
                    <v-btn class="ma-0 mr-3 px-5 py-4" value="Stock">
                        Stock
                    </v-btn>
                    <v-btn class="ma-0 mr-3 px-5 py-4" value="Stationary">
                        Stationary
                    </v-btn>
                </v-btn-toggle>
            </div>
        </v-flex>
        <v-row class="d-block grey lighten-4" no-gutters>
            <v-toolbar
                flat
                class="pa-0 transparent"
            >
                <v-btn color="black lighten-2" text class="btn-filter pa-1" @click="filterOpened = !filterOpened">Filters <v-icon right>$filter</v-icon></v-btn>

                <div class="ml-5">
                    <v-chip v-for="chip in filterChips" :key="chip.id"
                            close small
                            v-on:click:close="removeTag(chip)"
                            close-icon="mdi-close" color="primary" class="ma-1 lighten-1">
                        {{chip.title}}
                    </v-chip>
                </div>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-expand-transition>
                <v-card v-show="filterOpened" elevation="0" class="px-5 transparent" height="auto" style=" width: 100%;" :disabled="isLoading">
                    <v-row>
                        <v-col xs-3 class="align-flex-start" v-for="(filters, index) in filterLayout" :key="index">
                            <v-flex class="d-flex mb-5 test" v-for="filterItem in filters" :key="filterItem.title">
                                <div class="pt-2" style="width: 80px;">{{filterItem.title}}</div>
                                <v-select
                                    multiple
                                    v-model="filterOptions[filterItem.data]"
                                    :items="metaData[filterItem.data]"
                                    item-text="value"
                                    item-value="id"
                                    :placeholder="'Select ' + filterItem.title.substr(0, filterItem.title.length - 1)"
                                    dense
                                    solo
                                    lighten-1
                                    class="ml-2"
                                >
                                    <template v-slot:selection="{ item, index }">
                                        <span v-if="index === 0" class="selection-text-style">{{ filterItem.type === 'arr' ? item : item.value}}</span>
                                        <span
                                            v-if="index === 1"
                                            class="grey--text caption"
                                        >(+{{ filterOptions[filterItem.data].length - 1 }} others)</span>
                                    </template>
                                </v-select>
                            </v-flex>
                        </v-col>
                        <v-col xs-3 class="align-flex-start">
                            <v-flex class="d-flex" style="margin-top: -10px;">
                                <div class="pt-4 mr-2" style="min-width: 85px;">Date:</div>
                                <div>
                                    <div>
                                        <v-menu
                                            v-model="fromDatepickerStatus"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    :value="Date.formatDate([filterOptions.from])"
                                                    label="Due date from"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker first-day-of-week="1" v-model="filterOptions.from" @input="fromDatepickerStatus = false"></v-date-picker>
                                        </v-menu>
                                    </div>
                                    <div>
                                        <v-menu
                                            v-model="toDatepickerStatus"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            placeholer="from"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    :value="Date.formatDate([filterOptions.to])"
                                                    label="Due date to"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker first-day-of-week="1" v-model="filterOptions.to" @input="toDatepickerStatus = false"></v-date-picker>
                                        </v-menu>
                                    </div>
                                </div>
                            </v-flex>
                        </v-col>
                    </v-row>

                </v-card>
            </v-expand-transition>
        </v-row>
        <v-row no-gutters v-if="this.orderList.length">
            <v-data-table
                style="width: 100%"
                :loading="isLoading"
                :headers="headers"
                :items="orderList"
                :options.sync="options"
                :items-per-page="10"
                :server-items-length="totalItems"
                no-data-text="No tasks"
                class="elevation-0 d-block order-list-table"
                :footer-props="{
          'items-per-page-options': [5,10,15,20],
        }"
            >
                <template v-slot:body="{ items }">
                    <tr :key="item.id" v-for="item of items" @click="viewOrder(item.id)">
                        <td>
                            {{item.title}}
                        </td>
                        <td>
                            {{item.amount}}
                        </td>
                        <td>
                            {{item.author}}
                        </td>
                        <td>
                            {{item.status}}
                        </td>
                        <td>
                            {{item.approver}}
                        </td>
                        <td>
                            {{Date.formatDate([item.approvingTime])}}
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <v-pagination v-if="totalPages > 1" v-model="options.page" :length="totalPages" :total-visible="paginationTotalVisible"></v-pagination>
        </v-row>
        <div v-else class="text-center pa-5">
            <b> No orders </b>
        </div>
    </v-container>
</template>

<script>
    import MainAppBar from '@/components/MainAppBar'
    import { mapActions, mapGetters } from 'vuex'
    import config from '@/common/config'

    const defaultFilterOptions = {
        statuses: [],
        authors: [],
        from: '',
        to: ''
    }

    export default {
        components: {
            MainAppBar
        },
        data: () => ({
            orderType: 'Stock',
            orderList: [],
            monthlyBudget: 0,
            isLoading: false,
            filterOpened: false,
            totalItems: 0,
            fromDatepickerStatus: false,
            toDatepickerStatus: false,
            paginationTotalVisible: config.paginationTotalVisible,
            metaData: {},
            filterLayout: {},
            filterOptions: { ...defaultFilterOptions },
            headers: [
                {
                    text: 'Title',
                    align: 'left',
                    sortable: true,
                    value: 'title'
                },
                {
                    text: 'Amount',
                    align: 'left',
                    sortable: true,
                    value: 'amount'
                },
                {
                    text: 'Author',
                    align: 'left',
                    sortable: true,
                    value: 'author'
                },
                {
                    text: 'Status',
                    align: 'left',
                    sortable: true,
                    value: 'status'
                },
                {
                    text: 'Approver',
                    align: 'left',
                    sortable: true,
                    value: 'approver'
                },
                {
                    text: 'Time',
                    align: 'left',
                    sortable: true,
                    value: 'time'
                }
            ],
            options: {
                page: 1,
                itemsPerPage: 20,
                sortBy: ['title'],
                sortDesc: [false],
                groupBy: Array(0),
                groupDesc: Array(0),
                mustSort: false,
                multiSort: false
            }
        }),
        watch: {
            userClinicId (val) {
                this.getOrderListDebounce()
            },
            currentClinicRoles () {
                this.getOrderListDebounce()
            },
            filterOptions: {
                handler () {
                    this.getOrderListDebounce()
                },
                deep: true
            },
            options: {
                handler () {
                    this.getOrderListDebounce()
                },
                deep: true
            },
            orderType () {
                this.getOrderList()
            }
        },
        computed: {
            ...mapGetters({
                userClinicId: 'getUserActiveClinic'
            }),
            filterChips () {
                const filterTags = []
                for (const key in this.filterOptions) {
                    const optionValue = this.filterOptions[key]
                    if (Array.isArray(optionValue)) {
                        optionValue.forEach(opt => {
                            const tag = {
                                id: this.$uuid.v1(),
                                key
                            }
                            if (isFilterItemObj(key)) {
                                const tagInfo = this.metaData[key].find(metaItem => metaItem.id === opt)
                                tag.title = tagInfo.value
                                tag.value = tagInfo.id
                            } else if (isFilterItemBoolean(key)) {
                                if (opt) {
                                    tag.title = key.toUpperCase() + ' - true'
                                } else {
                                    tag.title = key.toUpperCase() + ' - false'
                                }
                                tag.value = opt
                            } else {
                                tag.title = opt
                                tag.value = opt
                            }
                            filterTags.push(tag)
                        })
                    } else {
                        const tag = {
                            id: this.$uuid.v1(),
                            key
                        }
                        if (isFilterItemDate(key)) {
                            tag.title = key.toUpperCase() + ' - ' + optionValue
                        } else {
                            if (optionValue) {
                                tag.title = key
                            }
                        }
                        tag.value = optionValue
                        if (optionValue) {
                            filterTags.push(tag)
                        }
                    }
                }
                return filterTags
                function isFilterItemObj (key) {
                    return ['statuses', 'authors'].indexOf(key) !== -1
                }
                function isFilterItemBoolean (key) {
                    return [].indexOf(key) !== -1
                }
                function isFilterItemDate (key) {
                    return ['from', 'to'].indexOf(key) !== -1
                }
            },
            totalPages () {
                return Math.ceil(this.totalItems / this.options.itemsPerPage)
            }
        },
        methods: {
            ...mapActions(['fetchOrderList']),
            viewOrder (id) {
                this.$router.push({ name: 'editOrder', params: { id: id } })
            },
            async getOrderList () {
                const params = {
                    orderType: this.orderType,
                    ...this.options,
                    filterOptions: {
                        ...this.filterOptions,
                        groupId: this.$store.getters.getUserActiveGroup,
                        clinicId: this.userClinicId,
                        sortField: this.options.sortBy[0] || 'id',
                        sortOrder: this.options.sortDesc[0] ? 'DESC' : 'ASC'
                    }
                }

                if (this.userClinicId) {
                    this.isLoading = true

                    try {
                        const { items, metadata } = await this.fetchOrderList(params)
                        this.totalItems = metadata.totalElements
                        this.orderList = items
                        this.metaData = metadata
                    } catch (e) {
                        this.totalItems = 0
                        this.orderList = []
                    }
                    this.isLoading = false
                }
            },
            getOrderListDebounce () {
                clearTimeout(this.filteringTimerId)
                this.filteringTimerId = setTimeout(this.getOrderList, 200)
            },
            removeTag (chip) {
                if (chip.key) {
                    const filterOption = this.filterOptions[chip.key]
                    if (Array.isArray(filterOption)) {
                        this.filterOptions[chip.key] = filterOption.filter(option => chip.value !== option)
                    } else {
                        this.filterOptions[chip.key] = defaultFilterOptions[chip.key]
                    }
                }
            }
        },
        async mounted () {
            this.getOrderListDebounce()
            this.filterLayout = [
                [
                    {
                        title: 'Statuses:',
                        data: 'statuses',
                        model: 'statuses',
                        type: 'obj'
                    },
                    {
                        title: 'Author:',
                        data: 'authors',
                        model: 'authors',
                        type: 'obj'
                    }
                ]
            ]
        }
    }
</script>

<style scoped lang="scss">
    .order-list-table {
        td {
            cursor: pointer;
        }
    }
    .v-data-table {
        width: 100%;
    }

    .btn-filter {
        svg {
            fill: #000
        }
    }
    .selection-text-style {
        font-size: 13px;
    }
    .expand-transition-enter-active, .expand-transition-leave-active {
        transition: .3s cubic-bezier(.25,.8,.5,1);
    }
</style>
